import React from "react";
import { postRequest } from "./QuoteApiService";

export const getItemsTypeahead = (rec) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest('GetItemsTypeahead/', rec)
      .then((res) => {
        console.log("GetItemsTypeahead > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("GetItemsTypeahead > axios err=", err);
        reject("Error in getAllUsers axios!");
      });
    } catch (error) {
      console.error("in services > GetItemsTypeahead, Err===", error);
      //NOTE: must reject. Without this the promise never settles on a synchronous throw, so a caller's
      //      .finally never runs and its loading spinner stays up forever.
      reject(error);
    }
  });
  
}
